import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cvjm',
  templateUrl: './cvjm.component.html',
  styleUrls: ['./cvjm.component.css']
})
export class CvjmComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
